module.exports = {
	setToDestroy: function(event, $content) {
		this.toDestroy = this._findModules($content);
	},	
}